import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";

export const ProjectCard = ({ project, index = 0 }) => {
  const flip = index % 2 === 1;
  return (
    <article
      className="group rounded-2xl border border-border bg-card overflow-hidden hover:border-primary/30 hover:shadow-xl transition-all duration-300"
      data-testid={`project-card-${project.id}`}
    >
      <div className="grid md:grid-cols-2">
        <div
          className={`relative aspect-[4/3] md:aspect-auto md:min-h-[300px] bg-muted overflow-hidden ${
            flip ? "md:order-2" : ""
          }`}
        >
          {project.image ? (
            <img
              src={project.image}
              alt={project.title}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center group-hover:scale-105 transition-transform duration-500">
              <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center">
                <span className="text-3xl font-bold text-primary">{project.monogram}</span>
              </div>
            </div>
          )}
          <div className="absolute top-4 left-4">
            <span className="inline-flex items-center rounded-full bg-white/90 text-gray-800 font-medium px-3 py-1 text-xs backdrop-blur-sm shadow-sm">
              {project.category}
            </span>
          </div>
        </div>

        <div className="p-6 md:p-10 flex flex-col justify-center space-y-4">
          <div className="w-12 h-1 bg-primary rounded-full" />
          <div className="flex items-center justify-between gap-4">
            <h4 className="text-2xl font-bold text-foreground group-hover:text-primary transition-colors">
              <Link to={`/projects/${project.id}`}>{project.title}</Link>
            </h4>
            {project.year && (
              <span className="text-lg font-semibold text-muted-foreground">{project.year}</span>
            )}
          </div>
          <p className="text-muted-foreground leading-relaxed">{project.description}</p>
          {project.role && (
            <p className="text-sm text-muted-foreground">
              <span className="font-semibold text-foreground">Role:</span> {project.role}
            </p>
          )}
          {project.tags.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {project.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/10"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}
          <div className="flex flex-wrap gap-3 pt-2">
            {project.liveUrl && (
              <a
                href={project.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`card-live-${project.id}`}
                className="inline-flex items-center justify-center gap-2 h-10 rounded-md px-6 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-md hover:shadow-lg transition-all duration-300"
              >
                <Play className="h-4 w-4" />
                View Live
              </a>
            )}
            <Link
              to={`/projects/${project.id}`}
              data-testid={`card-case-study-${project.id}`}
              className="group/btn inline-flex items-center justify-center gap-2 h-10 rounded-md px-6 text-sm font-medium border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            >
              Case Study
              <ArrowRight className="h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;
